import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ru from './locales/ru.json';
import pl from './locales/pl.json';
import de from './locales/de.json';
import fr from './locales/fr.json';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            'en-GB': { translation: en },
            ru: { translation: ru },
            pl: { translation: pl },
            de: { translation: de },
            fr: { translation: fr },
        },
        lng: 'en-GB',  // Устанавливаем британский английский по умолчанию
        fallbackLng: 'en-GB',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
